import React from "react";

import "./TermsandConditions.css";

const TermsandConditions = () => {
  return (
    <>
      <div className="termsContent">
          <h6>Acceptance of these terms</h6>
          <p>
            By using this website or placing a rental order, you agree to these
            terms and the policies linked on this website. You must provide
            accurate contact, delivery, sizing, and event-date information.
          </p>
          <h6>Rental orders and availability</h6>
          <p>
            A booking is confirmed only after we accept the order and any
            required payment or security deposit is received. Product colours,
            fit, and detailing may vary slightly because of lighting, screens,
            alterations, or normal use of rental garments.
          </p>
          <h6>Customer responsibilities</h6>
          <p>
            Please inspect the garment after delivery and contact us promptly if
            it is incorrect or damaged. Do not wash, permanently alter, lend, or
            misuse a rented item. Return it with all supplied accessories by the
            agreed date and in substantially the same condition, allowing for
            reasonable wear.
          </p>
          <h6>Late return, loss, and damage</h6>
          <p>
            Late-return charges may apply when an item is not returned on time.
            The customer is responsible for loss, theft, unauthorised alterations,
            and damage beyond reasonable wear. Any deduction will be based on the
            cleaning, repair, replacement, and related costs reasonably incurred.
          </p>
          <h6>Payments, cancellations, and refunds</h6>
          <p>
            Available payment methods are shown at checkout. Cancellation and
            refund eligibility depends on the order status and is governed by
            our Refund Policy. Delivery and return arrangements are governed by
            our Shipping Policy.
          </p>
          <h6>Governing Law & Jurisdiction</h6>
          <p>
            These terms are governed by the laws of India. Subject to applicable
            consumer-protection law, disputes will be handled by the courts with
            jurisdiction in Mumbai, Maharashtra.
          </p>
        </div>
    </>
  );
};

export default TermsandConditions;
